<template>
  <div class="header_inner">
    <div class="back_btn" @click="handleBack">
      <div class="back_icon" :style="backIconStyle"></div>
    </div>
    <div class="header_title" :style="{ color }">
      <slot>{{ title }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavTLeft',
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#1d1d1d'
    }
  },
  computed: {
    backIconStyle() {
      return {
        borderLeftColor: this.color,
        borderBottomColor: this.color,
      }
    }
  },
  methods: {
    handleBack() {
      const hasListener = this.$listeners && this.$listeners.back
      this.$emit('back')
      if (hasListener) return
      uni.navigateBack()
    }
  }
}
</script>

<style lang="scss" scoped>
.header_inner {
  position: relative;
  display: flex;
  align-items: center;
  height: calc(2.2rem) ;
  padding: 0 0.6rem;
}

.back_btn {
  width: 1.4rem;
  height: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.back_icon {
  width: 0.55rem;
  height: 0.55rem;
  border-left: 2px solid #1d1d1d;
  border-bottom: 2px solid #1d1d1d;
  transform: rotate(45deg);
}

.header_title {
  margin-left: 0.15rem;
  color: #1d1d1d;
  font-size: 0.8rem;
  font-weight: 700;
}
</style>
